export enum RotinaAgendamentoParametroTipoEnum {

  EXPRESSAO,
  LITERAL
}
